import { isNil } from "lodash/fp";

import { SwitchProps } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";

import Switch from "@app/common/components/Switch";

import TooltipWrapper from "@rui/TooltipWrapper";

export interface SettingsToggleProps extends SwitchProps {
  disabledTooltip?: string;
  label?: string;
}
const SettingsToggle = ({
  disabled,
  disabledTooltip,
  checked,
  onChange,
  label,
  sx,
}: SettingsToggleProps) => {
  return (
    <FormControlLabel
      labelPlacement="start"
      sx={{
        justifyContent: "space-between",
        height: "fit-content",
        mr: 0,
        ...sx,
      }}
      control={
        <TooltipWrapper
          arrow
          placement="bottom"
          show={disabled}
          title={disabledTooltip}
        >
          <Switch
            disabled={disabled}
            checked={checked}
            onChange={onChange}
            withStatusLabel={isNil(label)}
          />
        </TooltipWrapper>
      }
      label={
        label && (
          <Typography
            variant="bodySecondaryReg"
            sx={{ color: "shades.neutral.600" }}
          >
            {label}
          </Typography>
        )
      }
    />
  );
};
export default SettingsToggle;
